import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ArticleDetail from './pages/ArticleDetail';
import Page from './pages/Page';
import Categories from './pages/Categories';
import Search from './pages/Search';
import AuthorDetail from './pages/AuthorDetail';
import TagArticles from './pages/TagArticles';
import NotFound from './pages/NotFound';
import colors from './theme/colors';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${colors.lightGray};
`;

const MainContent = styled.main`
  flex: 1;
  background-color: ${colors.lightGray};
`;

/** Старі/зовнішні посилання часто використовують /pages/slug — у роутері лише /page/slug */
function RedirectPagesToPage() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/page/${slug ?? ''}`} replace />;
}

function App() {
  return (
    <Router>
      <AppContainer>
        <Header />
        <MainContent>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/article/:slug" element={<ArticleDetail />} />
            <Route path="/page/:slug" element={<Page />} />
            <Route path="/pages/:slug" element={<RedirectPagesToPage />} />
            <Route path="/about" element={<div>Сторінка "Про нас" незабаром буде доступна...</div>} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/search" element={<Search />} />
            <Route path="/author/:slug" element={<AuthorDetail />} />
            <Route path="/tag/:tag" element={<TagArticles />} />
            <Route path="/authors" element={<div>Сторінка авторів незабаром буде доступна...</div>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
